import { Add } from '@mui/icons-material';
import { useMutation } from '@apollo/client';
import { useState } from 'react';
import PropTypes from 'prop-types';

import { CREATE_WORKSPACE_INVITES } from '../../apis/workspace';
import { WORKSPACE_EMAIL_REGEX } from '../../constants/workspaces';
import Button from '../../components/atoms/button';
import InviteForm from '../../components/organisms/invite-user-form';
import Modal from '../../components/organisms/modal';
import useWorkspace from '../../context/WorkspaceContext';

export const emailRegex = new RegExp(WORKSPACE_EMAIL_REGEX);

const InviteUserModal = (props) => {
  // init
  const { setToast, onSuccess, existingUsers } = props;
  const { workspace, isFreeTrial, freeUsersLimit, setShowUpgradePlan } = useWorkspace();

  // states
  const [isOpenAddUser, setIsOpenAddUser] = useState(false);
  const [users, setUsers] = useState([{ email: '', role: 'employee' }]);
  const [error, setError] = useState('');

  // mutations/queries
  const [inviteUsers, { loading }] = useMutation(CREATE_WORKSPACE_INVITES);

  const onClickAddUserModal = () => {
    if (isFreeTrial && existingUsers + users.length - 1 >= freeUsersLimit) setShowUpgradePlan(true);
    else setIsOpenAddUser(true);
  };

  const validateEmails = () => {
    let isValid = true;
    for (let i = 0; i < users.length; i += 1) {
      if (!emailRegex.test(users[i].email)) {
        isValid = false;
        break;
      }
    }
    return isValid;
  };

  const handleInviteUsers = async () => {
    if (validateEmails()) {
      setError('');
      try {
        const variables = {
          workspaceId: workspace.id,
          input: [...new Set(users)],
        };
        const { data: { createWorkspaceInvites } } = await inviteUsers({ variables });
        if (createWorkspaceInvites.length !== 0) {
          setToast((prevstate) => ({ ...prevstate, open: true, type: 'success', message: 'Invitation sent successfully.' }));
        }
        setUsers([{ email: '', role: 'employee' }]);
        setError('');
        setIsOpenAddUser(false);
        onSuccess(createWorkspaceInvites);
      } catch (err) {
        setToast((prevstate) => ({ ...prevstate, open: true, type: 'error', message: 'Something went wrong while sending invitation.' }));
      }
    } else setError('Invalid Email address, please check above details and try again.');
  };

  const handleModalClose = () => {
    setIsOpenAddUser(false);
    setUsers([{ email: '', role: 'employee' }]);
    setError('');
  };

  return (
    <>
      <Modal
        title={`Invite Users to ${workspace.name} workspace`}
        body={<InviteForm existingUsers={existingUsers + users.length} setError={setError} validateEmails={validateEmails} setUsers={setUsers} users={users} error={error} />}
        secondaryButton={<Button isLoading={loading} disabled={loading} onClick={handleInviteUsers} primary>Send Invitation</Button>}
        primaryButton={(<Button disabled={loading} primary outlined onClick={handleModalClose} danger>Cancel</Button>)}
        isOpen={isOpenAddUser}
        setIsOpen={setIsOpenAddUser}
      />
      <Button onClick={onClickAddUserModal} primaryDark style={{ alignSelf: 'end' }} primary startIcon={<Add fontSize="small" />}>
        <strong>Invite Users</strong>
      </Button>
    </>
  );
};

InviteUserModal.propTypes = {
  setToast: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  existingUsers: PropTypes.number.isRequired,
};

export default InviteUserModal;
